import { BaseIcon } from './base';
import type { IconSmallProps } from './base';

export function IconComputer(props: IconSmallProps) {
  return (
    <BaseIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="currentColor"
        d="M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Zm2 0h14v11H5V5Z"
      />
      <path fill="currentColor" d="M2 20a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Z" />
    </BaseIcon>
  );
}
